<template>
  <div class="footer-link clearfix">
    <div class="flex pa-0 ma-0">
      <!--<div class="footer-nav footer-link-module">
        <ul>
          <li class="footer-link-module-title">{{$t("footer.nav.title")}}</li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <router-link tag="a" :to="langTo('/developer/')" class="header-tab-block" active-class="active">{{$t("header.nav.tab1")}}</router-link>
              </div>
              <div class="col-md-6">
                <router-link tag="a" :to="langTo('/miner/')" class="header-tab-block" active-class="active">{{$t("header.nav.tab2")}}</router-link>
              </div>
            </div>
          </li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <router-link tag="a" :to="langTo('/partner/')" class="header-tab-block" active-class="active">{{$t("header.nav.tab3")}}</router-link>
              </div>
              <div class="col-md-6">
                <router-link tag="a" :to="langTo('/news/')" class="header-tab-block" active-class="active">{{$t("header.nav.tab4")}}</router-link>
              </div>
            </div>
          </li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <router-link tag="a" to="langTo('/about/')" class="header-tab-block" active-class="active">{{$t("header.nav.tab5")}}</router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>-->

      <div class="footer-link-module">
        <ul>
          <li class="footer-link-module-title">{{$t("footer.community.title")}}</li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <a :href="$url.FOOTER_LINK.community.forum" target="_blank">
                  <i class="icon iconfont icon-forum"></i>
                  <span>{{$t("footer.community.tab7")}}</span>
                </a>
              </div>
              <div class="col-md-6">
                <a :href="$url.FOOTER_LINK.community.twitter" target="_blank">
                  <i class="icon iconfont icon-twitter"></i>
                  <span>{{$t("footer.community.tab2")}}</span>
                </a>
              </div>
            </div>
          </li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <a v-if="$i18n.locale === 'zh'" href="https://weibo.com/nknorg" target="_blank">
                  <img
                    src="../../assets/iconfont/weibo-logo.svg"
                    style="color: #ffffff;width: 16px;height: 16px;"
                  />
                  <span>{{$t("footer.community.tab8")}}</span>
                </a>
                <a v-else :href="$url.FOOTER_LINK.community.youtube" target="_blank">
                  <i class="icon iconfont icon-youtube"></i>
                  <span>{{$t("footer.community.tab6")}}</span>
                </a>
              </div>
              <div class="col-md-6">
                <a :href="$url.FOOTER_LINK.community.telegram" target="_blank">
                  <i class="icon iconfont icon-telegram"></i>
                  <span>{{$t("footer.community.tab1")}}</span>
                </a>
              </div>
            </div>
          </li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <a :href="$url.FOOTER_LINK.community.medium" target="_blank">
                  <i class="icon iconfont icon-medium"></i>
                  <span>{{$t("footer.community.tab5")}}</span>
                </a>
              </div>
              <div class="col-md-6">
                <a :href="$url.FOOTER_LINK.community.discord" target="_blank">
                  <i class="icon iconfont icon-discord"></i>
                  <span>{{$t("footer.community.tab4")}}</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="footer-link-module">
        <ul class="clearfix">
          <li class="footer-link-module-title">{{$t("footer.resource.title")}}</li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <a :href="$url.FOOTER_LINK.resource.github" target="_blank">
                  <i class="icon iconfont icon-github"></i>
                  <span>{{$t("footer.resource.tab1")}}</span>
                </a>
              </div>
              <div class="col-md-6">
                <a :href="$url.FOOTER_LINK.resource.devlopdoc" target="_blank">
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab5")}}</span>
                </a>
              </div>
            </div>
          </li>
          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <router-link tag="a" to="/WpDownload/">
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab3")}}</span>
                </router-link>
              </div>
              <div class="col-md-6">
                <a
                  v-if="'en' === lang"
                  :href="'/static/doc/NewKindofNetwork_EN.pdf'"
                  target="_blank"
                >
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab2")}}</span>
                </a>
                <a
                  v-else-if="'kr' === lang"
                  :href="'/static/doc/NewKindofNetwork_KR.pdf'"
                  target="_blank"
                >
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab2")}}</span>
                </a>
                <a v-else :href="'/static/doc/NewKindofNetwork_ZH.pdf'" target="_blank">
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab2")}}</span>
                </a>
              </div>
            </div>
          </li>

          <li class="footer-link-module-tab">
            <div class="row">
              <div class="col-md-6">
                <a
                  v-if="'en' === lang"
                  :href="'/static/doc/Towards Horizontal Scalable Information Propagation and MOCA Consensus in Massive-Scale Networks.pdf'"
                  target="_blank"
                >
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab6")}}</span>
                </a>
                <a
                  v-else-if="'kr' === lang"
                  :href="'/static/doc/Towards Horizontal Scalable Information Propagation and MOCA Consensus in Massive-Scale Networks.pdf'"
                  target="_blank"
                >
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab6")}}</span>
                </a>
                <a
                  v-else
                  :href="'/static/doc/Towards Horizontal Scalable Information Propagation and MOCA Consensus in Massive-Scale Networks.pdf'"
                  target="_blank"
                >
                  <i class="icon iconfont icon-word"></i>
                  <span>{{$t("footer.resource.tab6")}}</span>
                </a>
              </div>
              <div class="col-md-6">
                <router-link tag="a" to="/logodownload/">
                  <i class="icon iconfont icon-download"></i>
                  <span>{{$t("footer.resource.tab4")}}</span>
                </router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="wechat-qr" id="footer-wechat-qr" v-if="'zh' === lang">
        <div class="title">
          <img src="../../assets/iconfont/iconfont-weichat.svg" />
          <span>微信</span>
        </div>
        <div class="qr">
          <img src="/static/img/footer/weichatQR.jpg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
export default {
  mounted() {
    this.$nextTick(_ => {
      if ($(window).width() > 768) {
        return;
      }
      // $('#footer-wechat-qr').css({
      //   left: $('#footer-reddit').offset().left - 15,
      //   top: '38px',
      //   marginLeft: 'auto',
      //   marginRight: 'auto'
      // })
    });
  },
  computed: {
    ...mapState({
      lang: state => state.lang.lang
    })
  },
  methods: {
    langTo(path) {
      let root = "";
      if (!!this.$route.params.lang) {
        root = `/${this.$route.params.lang}`;
      }
      return `${root}${path}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-link {
  position: relative;
  text-align: left;
  .col-md-12,
  .col-md-6 {
    padding: 0 !important;
  }
  .flex {
    position: relative;
    display: flex;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
  }
  .wechat-qr {
    right: 50px;
    top: 56px;
    margin-left: 20px;
    z-index: 2;
    .title {
      img {
        vertical-align: middle;
        width: 24px;
      }
      span {
        vertical-align: middle;
        font-size: 16px;
        color: #ffffff;
        font-weight: 300;
      }
      padding-bottom: 10px;
    }
    .qr {
      img {
        width: 90px;
      }
    }
    @media screen and (max-width: 768px) {
      position: absolute;
      right: 0;
      bottom: -40px;
      top: auto;
      margin-left: auto;
      margin-right: auto;
      .title {
        img {
          vertical-align: middle;
          width: 18px;
          margin-right: 4px;
        }
        span {
          vertical-align: middle;
          font-size: 0.9rem;
          color: #ffffff;
          font-weight: 300;
        }
        padding-bottom: 10px;
      }
      .qr {
        img {
          width: 60px;
          margin-left: 4px;
        }
      }
    }
  }
  width: 700px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  .footer-link-outer {
    padding: 0;
  }
  @media screen and (min-width: 768px) {
    .footer-nav {
      display: none;
    }
  }
  @media screen and (max-width: 768px) {
    padding: 0;
    padding-top: 20px;
    .footer-link-outer {
      padding: 0;
      position: relative;
    }
  }
  @media screen and (max-width: 768px) {
    .resource-link {
      ul {
        li {
          width: 25% !important;
          .col-md-12 {
            width: 100%;
            padding: 0;
          }
        }
        li:nth-child(4) {
          margin-left: 20px;
        }
        li:nth-child(5) {
          width: 100% !important;
        }
      }
    }
    .footer-link-module {
      margin-bottom: 20px;
    }
    ul {
      li {
        float: left !important;
        width: 48% !important;
        .col-md-6 {
          width: 50% !important;
          padding: 0;
        }
      }
      li.footer-link-module-title {
        width: 300px !important;
        @media screen and (max-width: 768px) {
          width: 100% !important;
        }
      }
    }
  }

  padding: 60px 0;
  &-module {
    float: left;
    /*min-width: 440px;*/
    color: #fff;
    &-title {
      @include nkn-font-set(1.2rem, currentColor);
      padding: 0;
      padding-bottom: 10px;
      @media screen and (max-width: 768px) {
        font-weight: 600;
      }
    }

    &-tab {
      @include nkn-font-set(0.9rem, currentColor, 300);
      padding: 6px 0;
      line-height: 1.5rem;
      cursor: pointer;

      .col-md-12,
      .col-md-6 {
        padding-left: 0;
      }

      .col-md-6 {
        float: left;
        width: 140px;
      }
      & > a {
        display: inline-block;
        color: currentColor;
        width: 220px;

        & > i {
          margin-right: 0.8rem;
          font-size: 1.2rem;
          vertical-align: -1px;
        }

        &:hover {
          color: #1791f2;
        }

        &:active {
          text-decoration: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/nknFooterLink.vue